export const groupRegistrations = (registrations) => {
    const grouped = {
      active: [],
      waitlist: [],
      cancelled: [],
      deleted: [],
    };
  
    registrations.forEach((r) => {
      if (r.status === 6) {
        grouped.deleted.push(r);
      } else if (r.status === 5) {
        grouped.cancelled.push(r);
      } else if (r.status === 2) {
        grouped.waitlist.push(r);
      } else if (r.status === 3 || r.status === 4 || !r.createdAt) {
        grouped.active.push(r);
      }
    });
  
    for (let key in grouped) {
      grouped[key].sort((a, b) => {
        if (key === "cancelled") {
          return new Date(b.cancelledAt || 0) - new Date(a.cancelledAt || 0);
        } else if (key === "deleted") {
          return new Date(b.deletedAt || 0) - new Date(a.deletedAt || 0);
        } else {
          return new Date(a.prereservationAt || 0) - new Date(b.prereservationAt || 0);
        }
      });
    }
  
    return grouped;
  };
  
  export const getTotalParticipants = (registrations) =>
    registrations.reduce((sum, r) => {
      if (!r.createdAt) return sum + (r.pax || 0);
      return sum + (r.participants?.filter((p) => p.status !== 4 && p.status !== 5).length || 0);
    }, 0);
  